// Lib
import React, { createContext } from 'react';
import { Provider, createDispatchHook } from 'react-redux';

export const EditorStoreContext = createContext();

export const EditorStoreProvider = (props) => <Provider context={EditorStoreContext} {...props} />;

export const useEditorDispatch = createDispatchHook(EditorStoreContext);
